<template>
  <div class="delete-account">
    <h2>Delete Account</h2>

    <div class="field">
      <label>Email</label>
      <input type="email" v-model="email" placeholder="Enter your email" />
    </div>

    <div class="field">
      <label>Password</label>
      <input type="password" v-model="password" placeholder="Enter your password" />
    </div>

    <div class="field">
      <label>Type DELETE to confirm</label>
      <input type="text" v-model="confirmationText" placeholder="Type DELETE" />
    </div>

    <p class="info-text">
      To confirm account deletion, type <strong>DELETE</strong> and enter your password.
    </p>

    <div class="actions">
      <button class="delete-btn" :disabled="processing" @click="handleDelete">
        {{ processing ? 'Processing...' : 'Delete Account' }}
      </button>

      <router-link to="/" class="cancel-btn">
        Cancel
      </router-link>
    </div>

    <p v-if="error" class="error">{{ error }}</p>
  </div>
</template>

<script>
import { ref } from 'vue'
import {
  signInWithEmailAndPassword,
  deleteUser
} from 'firebase/auth'
import { httpsCallable } from 'firebase/functions'
import { auth, functions } from '../firebaseConfig.js'

export default {
  setup () {
    const email = ref('')
    const password = ref('')
    const confirmationText = ref('')
    const processing = ref(false)
    const error = ref(null)

    const handleDelete = async () => {
      error.value = null

      if (!email.value || !password.value) {
        error.value = 'Please enter your email and password.'
        return
      }

      if (confirmationText.value !== 'DELETE') {
        error.value = 'Please type DELETE to confirm.'
        return
      }

      processing.value = true

      try {
        // 1️⃣ Login temporário
        const { user } = await signInWithEmailAndPassword(auth, email.value, password.value)

        // 2️⃣ Deleta dados associados (Cloud Function)
        const deleteFn = httpsCallable(functions, 'deleteAccount')
        await deleteFn()

        // 3️⃣ Apaga a conta do Firebase Auth
        await deleteUser(user)

        // 4️⃣ Mensagem final e redirecionamento
        alert('🎯 You have successfully deleted your account!')
        window.location.href = '/'
      } catch (err) {
        console.error('Delete error:', err)

        if (err.code === 'auth/user-token-expired') {
          alert('🎯 Your account was successfully deleted!')
          window.location.href = '/'
          return
        }

        if (err.code === 'auth/user-not-found') {
          error.value = 'No account found with this email.'
        } else if (err.code === 'auth/wrong-password') {
          error.value = 'Incorrect password. Please try again.'
        } else {
          error.value =
            err.message || 'Error deleting account. Please try again.'
        }
      } finally {
        processing.value = false
      }
    }

    return {
      email,
      password,
      confirmationText,
      processing,
      error,
      handleDelete
    }
  }
}
</script>

<style scoped>
.delete-account {
  max-width: 400px;
  margin: 50px auto;
  padding: 25px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
  font-family: 'Arial', sans-serif;
}

h2 {
  text-align: center;
  margin-bottom: 20px;
  color: #222;
}

.field {
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
}

label {
  margin-bottom: 5px;
  font-weight: 600;
  color: #444;
}

input {
  padding: 10px 12px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 14px;
}

.info-text {
  font-size: 13px;
  color: #555;
  margin-bottom: 15px;
}

.actions {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

button,
.cancel-btn {
  padding: 10px 15px;
  border: none;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
  text-align: center;
}

.delete-btn {
  background-color: #e74c3c;
  color: white;
}

.delete-btn:disabled {
  background-color: #f5a9a8;
  cursor: not-allowed;
}

.cancel-btn {
  background-color: #bdc3c7;
  color: #222;
}

.error {
  margin-top: 15px;
  color: #e74c3c;
  font-weight: 600;
}
</style>
